<template>
  <div>
    <v-row align="center">
      <span>ภาษา :</span>
      <v-checkbox class="ma-1 pa-0" v-model="searchParams.th" label="ภาษาไทย" hide-details></v-checkbox>
      <v-checkbox class="ma-1 pa-0" v-model="searchParams.en" label="ภาษาอังกฤษ" hide-details></v-checkbox>
    </v-row>
    <v-row align="center">
      <span>สถานะ :</span>
      <v-checkbox class="ma-1 pa-0" v-model="searchParams.isWait" label="รอการตรวจสอบ" hide-details></v-checkbox>
      <v-checkbox
        class="ma-1 pa-0"
        v-model="searchParams.isProcess"
        label="อยู่ระหว่างดำเนินการ"
        hide-details
      ></v-checkbox>
      <v-checkbox class="ma-1 pa-0" v-model="searchParams.isDone" label="จัดทำเรียบร้อยแล้ว" hide-details></v-checkbox>
    </v-row>
    <v-row align="center">
      <span>เหตุผล :</span>
      <v-checkbox class="ma-1 pa-0" v-model="searchParams.isBank" label="ติดต่อสถาบันการเงิน" hide-details></v-checkbox>
      <v-checkbox class="ma-1 pa-0" v-model="searchParams.isVisa" label="ขอวีซ่าเดินทาง" hide-details></v-checkbox>
      <v-checkbox class="ma-1 pa-0" v-model="searchParams.isOther" label="อื่นๆ" hide-details></v-checkbox>
    </v-row>

    <v-row>
      <v-col class="py-2 px-0" lg="6" cols="12">
        <v-text-field v-model="searchParams.firstName" label="ชื่อ" outlined dense hide-details></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-2 px-0" lg="6" cols="12">
        <v-text-field v-model="searchParams.lastName" label="นามสกุล" outlined dense hide-details></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-2 px-0" lg="6" cols="12">
        <v-autocomplete
          v-model="searchParams.orgParent"
          :items="orgParentList"
          item-text="title"
          item-value="value"
          outlined
          dense
          label="หน่วยงาน"
          hide-details
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row v-if="searchParams.orgParent && orgChildList.length > 0">
      <v-col class="py-2 px-0" lg="6" cols="12">
        <v-autocomplete
          v-model="searchParams.orgChild"
          :items="orgChildList"
          item-text="title"
          item-value="value"
          outlined
          dense
          label="หน่วยงาน"
          hide-details
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-2 px-0" lg="6" cols="12">
        <app-country-list
          title="ประเทศที่เดินทางไป"
          :value="countryID"
          @input="
            value => {
              searchParams.country = value.countryNameTha;
              countryID = value.countryID;
            }
          "
        ></app-country-list>
        <!-- <v-autocomplete
          v-model="country"
          :items="countryLists"
          label="ประเทศที่เดินทางไป"
          outlined
          dense
          hide-details
        ></v-autocomplete> -->
      </v-col>
    </v-row>

    <v-row>
      <v-col lg="3" sm="6" cols="12" class="py-2 " :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-0'">
        <v-menu
          v-model="startDateDialog"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="$dateFormatByLang(searchParams.StartDate)"
              label="ตั้งแต่วันที่"
              append-icon="mdi-calendar"
              readonly
              outlined
              hide-details="auto"
              dense
              v-on="on"
              @click:append="startDateDialog = true"
            ></v-text-field>
          </template>
          <v-date-picker
            :locale="$lang === 'Tha' ? 'th' : 'en'"
            v-model="searchParams.StartDate"
            @input="startDateDialog = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col lg="3" sm="6" cols="12" class="py-2 " :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pr-0'">
        <v-menu
          v-model="endDateDialog"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="$dateFormatByLang(searchParams.EndDate)"
              label="ถึงวันที่"
              append-icon="mdi-calendar"
              readonly
              outlined
              hide-details="auto"
              dense
              v-on="on"
              @click:append="endDateDialog = true"
            ></v-text-field>
          </template>
          <v-date-picker
            :locale="$lang === 'Tha' ? 'th' : 'en'"
            v-model="searchParams.EndDate"
            @input="endDateDialog = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-checkbox
        class="ma-1 pa-0"
        v-model="searchParams.EarlyStatus"
        label="ค้นหาบุคลากรเกษียณ"
        hide-details
      ></v-checkbox>
    </v-row>
    <v-row>
      <v-col class="py-2 px-0" lg="6" cols="12">
        <v-btn @click="setQuery()" class="full-width" color="primary"> ค้นหา</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import countryList from '@/assets/json/countryList.json';
import AppCountryList from '@/components/base/AppCountryList.vue';
export default {
  components: [AppCountryList],
  data() {
    return {
      searchParams: {
        th: false,
        en: false,
        isWait: false,
        isProcess: false,
        isDone: false,
        isBank: false,
        isVisa: false,
        isOther: false,
        firstName: '',
        lastName: '',
        orgParent: '',
        orgChild: '',
        country: '',
        StartDate: '',
        EndDate: '',
        EarlyStatus: false
      },
      title: 'สถานะคำขอรับรอง',
      reason: 1,
      count: 1,
      orgParentList: [],
      orgChildList: [],
      startDateDialog: false,
      endDateDialog: false,
      countryID: ''
    };
  },
  computed: {
    countryLists() {
      let data = [];
      countryList.forEach(item => {
        data.push(item.country);
      });
      return data;
    },
    orgParent() {
      return this.searchParams.orgParent;
    }
  },
  async mounted() {
    this.orgParentList = await this.getOrgParent();
    this.searchParams.orgParent = this.orgParentList[0].value || '';
    this.orgChildList = await this.getOrgChild();
    if (this.orgChildList.length > 0) {
      this.searchParams.orgChild = this.orgChildList[0].value || '';
    }

    const query = this.$route.query;
    this.searchParams.th = query.th === 'true' ? true : false;
    this.searchParams.en = query.en === 'true' ? true : false;
    this.searchParams.isWait = query.isWait === 'true' ? true : false;
    this.searchParams.isProcess = query.isProcess === 'true' ? true : false;
    this.searchParams.isDone = query.isDone === 'true' ? true : false;
    this.searchParams.isBank = query.isBank === 'true' ? true : false;
    this.searchParams.isVisa = query.isVisa === 'true' ? true : false;
    this.searchParams.isOther = query.isOther === 'true' ? true : false;
    this.searchParams.EarlyStatus = query.EarlyStatus === 'true' ? true : false;

    await this.setQuery();
  },
  watch: {
    async orgParent() {
      this.orgChildList = await this.getOrgChild();
      if (this.orgChildList.length > 0) {
        this.searchParams.orgChild = '0';
      } else {
        this.searchParams.orgChild = '';
      }
    }
  },
  methods: {
    setQuery() {
      this.$router.push({ query: this.searchParams }).catch(() => {
        console.log('same page, same result');
      });
    },
    async getOrgParent() {
      const res = await this.apiGetOrgParent();
      const lang = this.$lang;
      let list = [];

      res.forEach(item => {
        list.push({
          title: item[`organizationName${lang}`] ? item[`organizationName${lang}`] : '',
          value: item.organizationID ? item.organizationID : ''
        });
      });
      return list;
    },
    async getOrgChild() {
      const res = await this.apiGetOrgChild();
      const lang = this.$lang;
      let list = [];

      res.forEach(item => {
        list.push({
          title: item[`organizationName${lang}`] ? item[`organizationName${lang}`] : '',
          value: item.organizationID ? item.organizationID : ''
        });
      });
      return list;
    },
    async apiGetOrgParent() {
      try {
        const res = await this.$store.dispatch('reqCer/getOrgParent');
        return res.data.data;
      } catch (e) {
        console.log(e.response || e);
      }
    },
    async apiGetOrgChild() {
      try {
        const res = await this.$store.dispatch('reqCer/getOrgChild', this.orgParent);
        return res.data.data;
      } catch (e) {
        console.log(e.response || e);
      }
    }
  }
};
</script>
